import { render } from "./FrontofficeHome.vue?vue&type=template&id=3fea470a&ts=true"
import script from "./FrontofficeHome.vue?vue&type=script&lang=ts"
export * from "./FrontofficeHome.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__